import { useAppDispatch } from './useAppDispatcher.hook';
import { getPersonExperienceListThunk } from '../redux/Candidate/Experience/PersonExperience.thunk';
import { PersonExperience } from '../redux/Candidate/Experience/PersonExperience.type';

const useExperienceHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (search: string, loadedOptions: string | any[]) => {
      const {
        payload: { data },
      } = await dispatch(getPersonExperienceListThunk({}));
      return {
        options: data.map((item: PersonExperience) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: false,
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getPersonExperienceListThunk({ ids }));
      return data.map((item: PersonExperience) => ({
        value: item.id,
        label: item.name,
      }));
    },
  };
};

export default useExperienceHook;
